import React from 'react';

export default function ConsagracionJesus() {
  return (
    <>
        <p>
        Sacratísimo Corazón Eucarístico de Jesús, Yo confío inmensamente en Tu Misericordia. <br/>Te pido humildemente que me des la fe que necesito para abandonarme a Tu Infinita Misericordia, porque ya se han agotado mis recursos humanos y ahora solo me cabe volverme con confianza a Tu Infinita Compasión, porque sé que Tú no desoirás mi súplica. <br/> Aquí estoy Señor a Tus pies pidiendo con fervor arregles todas mis cosas y problemas, según Tu Amor y Beneplácito divino, que sé, será lo mejor para mí, concédeme lo que te estoy pidiendo, si es para bien de mi alma. <br/><br/> ¡Toma Señor mi problema! ¡Toma mi corazón! <br/> ¡Yo confío en Ti, Corazón Eucarístico de Jesús! <br/> ¡Yo confío en Ti, Corazón Eucarístico de Jesús! <br/> ¡Yo confío en Ti, Corazón Eucarístico de Jesús!
        </p>
    </>
  );
}
